export default __webpack_public_path__ + "static/media/160x90.ab14182d.jpg";